import { type FunctionComponent } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import LoginWell from '../LoginWell.tsx';

import styles from './styles/DealerForgotPasswordConfirmation.scss';

const DealerForgotPasswordConfirmation: FunctionComponent = () => (
    <LoginWell
        heading={
            <FormattedMessage
                id="login.reset_confirmation_heading"
                defaultMessage="Check Your Email"
            />
        }
        subtitle={
            <FormattedMessage id="login.reset_confirmation_subtitle" defaultMessage="Step 2 of 3" />
        }
    >
        <div className={styles.confirmationContent}>
            <FormattedMessage
                id="login.reset_confirmation_copy"
                defaultMessage="Please check your inbox for an email from us. You'll need to follow the instructions in the email in order to continue."
            />
            <div className={styles.troubleshoot}>
                <p className={styles.troubleshootTitle}>
                    <FormattedMessage
                        id="login.reset_confirmation_tip_heading"
                        defaultMessage="Didn't get an email?"
                    />
                </p>
                <p>
                    <FormattedMessage
                        id="login.reset_confirmation_tip"
                        defaultMessage="Allow 10 minutes for the email to arrive. If you still don't see it, check your spam folder. Double check that you’ve entered the correct email address which can be found in the account set up email you received."
                    />
                </p>
            </div>
        </div>
    </LoginWell>
);

export default DealerForgotPasswordConfirmation;
